import { FC } from 'react';
import StartingRatesDesktop from './StartingRatesDesktop';
import StartingRatesMobile from './StartingRatesMobile';

type Props = {
  isMobileView?: boolean;
};

const StartingRates: FC<Props> = ({ isMobileView }) => {
  if (isMobileView) {
    return <StartingRatesMobile />;
  }

  return <StartingRatesDesktop />;
};

export default StartingRates;
